import styled from '@emotion/styled'

import { Modal } from '@onl-web/shared/components'

import { COLORS } from '@/styles/colors'

export const DialogBackdrop = styled(Modal.Backdrop)`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
`

export const DialogContent = styled(Modal.Content)`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${COLORS.bgWhite};
  border-radius: 24px;
  box-shadow:
    0 4px 4px rgba(0, 0, 0, 0.16),
    0 0 1px rgba(0, 0, 0, 0.12);
`

export const DialogTextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 24px 24px 0;
  text-align: center;
`

export const DialogTitle = styled(Modal.Title)`
  margin: 0;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.3px;
  color: ${COLORS.textPrimary};
`

export const DialogDescription = styled(Modal.Description)`
  margin: 0;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.08px;
  white-space: pre-line;
  color: ${COLORS.textSecondary};
`

export const DialogActions = styled(Modal.Actions)`
  display: flex;
  padding: 24px 16px 16px;
`

export const DialogConfirmButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background-color: ${COLORS.bgInverse};
  color: ${COLORS.textInverse};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  cursor: pointer;
`
